import { __rest, __assign } from '../node_modules/tslib/tslib.es6.esm.js';
import React__default, { forwardRef, useRef } from 'react';
import Calendar from '../assets/icons/Calendar.esm.js';
import classNames from 'classnames';
import NvInput from '../NvInput/NvInput.esm.js';

var DateField = forwardRef(function (_a, ref) {
    var showIcon = _a.showIcon, isDateRange = _a.isDateRange, isInputDisabled = _a.isInputDisabled, props = __rest(_a, ["showIcon", "isDateRange", "isInputDisabled"]);
    var internalRef = useRef(document.createElement('div'));
    return (React__default.createElement("div", { className: classNames('nv-calendar-input-wrapper ', { 'nv-calendar-input-range ': isDateRange }), ref: ref },
        React__default.createElement(NvInput, __assign({}, props, { disabled: isInputDisabled, ref: internalRef, suffixAction: function () { var _a, _b; return (_b = (_a = internalRef === null || internalRef === void 0 ? void 0 : internalRef.current) === null || _a === void 0 ? void 0 : _a.querySelector('input')) === null || _b === void 0 ? void 0 : _b.click(); }, suffixElement: showIcon && React__default.createElement(Calendar, { "data-testid": "icon", type: props.value ? 'solid' : 'stroke' }) }))));
});
DateField.displayName = 'DateField';

export { DateField as default };
//# sourceMappingURL=DateField.esm.js.map
